import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";

const C = { green: "#004D2B", greenMid: "#006B3C", cream: "#F9F6F1", text: "#1A1A1A", sub: "#6B6B6B", border: "#E2DDD7" };

export default function TermsOfService() {
  const { settings, loaded } = useSettings();

  return (
    <div style={{ minHeight: "100vh", background: C.cream, fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ maxWidth: 780, margin: "0 auto", padding: "48px 24px" }}>
        <Link to="/" style={{ color: C.greenMid, fontSize: 13, fontWeight: 600, textDecoration: "none" }}>← Retour à l'accueil</Link>
        <h1 style={{ color: C.green, fontSize: 28, fontWeight: 700, margin: "16px 0 24px" }}>Conditions générales d'utilisation</h1>
        <div style={{
          background: "#fff", border: `1px solid ${C.border}`, borderRadius: 16, padding: "32px 28px",
          color: C.text, fontSize: 14, lineHeight: 1.8, whiteSpace: "pre-wrap",
        }}>
          {!loaded ? "Chargement…" : (settings.termsOfService || "Contenu non disponible pour le moment.")}
        </div>
      </div>
    </div>
  );
}
